import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideRouter, withDisabledInitialNavigation, withEnabledBlockingInitialNavigation } from '@angular/router';
import { provideUiKitIcons } from '@jdi/jdi-ui-kit';
import { BrowserUtils } from '@azure/msal-browser';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalService
} from '@azure/msal-angular';

import { routes } from './app.routes';
import { AuthSessionService } from './core/auth/services/auth-session.service';
import { ApplicationInsightsTelemetryService } from './core/services/application-insights-telemetry.service';
import { msalGuardConfigFactory } from './core/auth/msal/msal-guard-config.factory';
import { msalInstanceFactory } from './core/auth/msal/msal-instance.factory';
import { msalInterceptorConfigFactory } from './core/auth/msal/msal-interceptor-config.factory';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      ...(BrowserUtils.isInPopup()
        ? [withDisabledInitialNavigation()]
        : [withEnabledBlockingInitialNavigation()])
    ),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(MsalModule),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: msalInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: msalGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: msalInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    provideAppInitializer(() => {
      inject(ApplicationInsightsTelemetryService).initialize();
      const authSessionService = inject(AuthSessionService);
      return authSessionService.initialize();
    }),
    provideUiKitIcons({
      mode: 'consumer-first',
      consumerBasePaths: ['/assets/icons'],
      useTablerDefault: true,
      allowedOrigins: []
    })
  ]
};
